import { usePermanentHoldingLocations, usePermanentLocations } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

import type { Appointment } from "models";

export const useAppointmentLocation = (appointment?: Appointment) => {
  const { locations } = usePermanentLocations();
  const { holdingLocations } = usePermanentHoldingLocations();

  const location_id = appointment?.dealer_location_id ?? typedQueryClient.getQueryData(AppointmentDetailsKeys.view)?.dealer_location_id;
  if (!location_id) return;

  return locations.find(location => location.id === location_id) ?? holdingLocations.find(location => location.id === location_id);
};
